export default __webpack_public_path__ + "static/media/med-del.fbae069a.svg";